
import { TUIConversationService } from '@tencentcloud/chat-uikit-engine';
import { getChannelByDoctorId } from "@/api/cf";
import { getHxMessageHistory, addTencentGroup } from "@/api/chat";
import myJsTools from '@/utils/myJsTools';
import { Toast } from 'vant';
import { stopLoading, startLoading  } from '@/utils/public';
import EventBus from '@/utils/eventBus';

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {}
      },
      methods: {
        /**
         * @param {*} useID  跳转的im的useID 
         * @param {*} item  当前接诊中的问诊信息
         */
        async goToIm(useID, item) {
          console.log('点击当前问诊列表item', item);
          const docInfoRes = await this.getCurDocInfo(item)
            if (+docInfoRes?.code === 20000) {
              const obj = docInfoRes.data
              let curChannelInfo = {};
              for (let key in obj) {
                if (obj[key] === null) {
                    curChannelInfo[key] = '';
                } else {
                    curChannelInfo[key] = obj[key];
                }
              }
              try {
                let groupInfo = await this.enterGroup(item)
                console.log('groupInfo', groupInfo);
              } catch (error) {
                
              }
             await this.goToCurIm(item, curChannelInfo, useID)
            }
        },
        async getCurPatientHxMessageHistory(item) {
          const docId = myJsTools.getItem('docAllInfo')?.docId || ''
          const params = {
            docId,
            patientId: item.patientId
          }
          let res = await getHxMessageHistory(params)
          return res.data
        },
        async getCurDocInfo(item) {
          const param = { patientId: item.patientId, regId: item.regId }
          let res = await getChannelByDoctorId(param)
          return res
        },
        async goToCurIm(item, curChannelInfo, useID) {
          // this.$store.commit("setIsChangeTab", 1)
          const docName = myJsTools.getItem('docUserInfo')?.docName || ''
          const patientName =  myJsTools.getItem('patientInfo')?.patientName  || ''
          const hxHistoryData = await this.getCurPatientHxMessageHistory(item)
          const curClickConInfo = {
            channelInfo: curChannelInfo,
            itemInfo: item,
            hxHistoryData: hxHistoryData
          }
          const telNo = myJsTools.getItem('docAllInfo')?.telNo || ''
          myJsTools.setItem('curClickConInfo', curClickConInfo)
          if (!telNo) {
            Toast('暂未获取到当前医生手机号')
            return
          }
          const groupID = `${telNo}${useID}`
          myJsTools.setItem('curgroupID', groupID)
          console.log('当前会话的groupID', groupID);
          if (this.$route.path != '/index') {
            this.$router.push('index')
          }
          console.log('进入IM会话', TUIConversationService);
          
          TUIConversationService.switchConversation(`GROUP${groupID}`).then(res => {
            console.log('进入then', res);
            this.$tracker.sendUserAction({
              message:  `#ACTION#-tuikit`,
              content:  `${docName}医生进入${patientName}的群聊`,
              target: "enter_tuikit",
            })
            stopLoading()
            if (res.code === -100002) { //同一个groupid  先初始化一下 然后再再次进入
              TUIConversationService.init()
              // .then(res => {
              //   TUIConversationService.switchConversation(`GROUP${groupID}`)
              // })
            } else {
              if (res.message) {
                this.$tracker.sendError({
                  errorMessage: `没有正常进入im诊室，当前code为${res.code},${JSON.stringify(res.message)}`,
                  errorType: '#SDK_TUIKIT#-warn',
                  errorStack: 'Error stack trace...'
                })
                Toast(res.message)
              }
            }
            EventBus.$emit('handleTurnIm', {
              currentConversationID: `GROUP${groupID}`
            })
          }).catch(err => {
            console.log('进入catch了', err);
            stopLoading()
            if(err.code == -100000) {
              Toast('请您重新登录或者清除浏览器缓存')
              EventBus.$emit('handleTurnIm', {
                currentConversationID: `GROUP${groupID}`
              })
            } else if (err.message) {
              this.$tracker.sendError({
                errorMessage: `没有正常进入im诊室，当前code为${err.code},${JSON.stringify(err.message)}`,
                errorType: '#SDK_TUIKIT#-warn',
                errorStack: 'Error stack trace...'
              })
              Toast(err.message)
            }
          });
        },
        // onMessageReceived(event) {
        //   // loadingInstance.close();
        //   stopLoading()
        //   TUIConversationService.switchConversation(`GROUP${groupID}`).catch(
        //     (error) => {
        //       console.warn('switch conversation failed:', error);
        //       Toast('进入会话失败');
        //     },
        //   );
        // },
        async enterGroup(item) {
          //  const telNo = myJsTools.getItem('docAllInfo')?.telNo || ''
          const params = {
            regId: item.regId
          }
          const res = await addTencentGroup(params)
          return res
        }
      }
    })
  }
}